enum NavTranslationVariant {
    gradeLevelTK = 'gradeLevelTK'
    , gradeLevelK = 'gradeLevelK'
    , gradeLevel1 = 'gradeLevel1'
    , gradeLevel2 = 'gradeLevel2'
    , gradeLevel3 = 'gradeLevel3'
    , gradeLevel4 = 'gradeLevel4'
    , studentWorkbook = 'studentWorkbook'
    , teachersGuide = 'teachersGuide'
    , lessonPlanner = 'lessonPlanner'
    , assignmentTracker = 'assignmentTracker'
    , resources = 'resources'
    , apps = 'apps'
    , appsTag = 'appsTag'
    , support = 'support'
    , logout = 'logout'
    , home = 'home'
    , navMenuOpenTag = 'navMenuOpenTag'
    , navMenuCloseTag = 'navMenuCloseTag'
    , teacherGuideSelectedTag = 'teacherGuideSelectedTag'
    , noTeacherGuideSelectedTag = 'noTeacherGuideSelectedTag'
    , activityBookSelectedTag = 'activityBookSelectedTag'
    , noActivityBookSelectedTag = 'noActivityBookSelectedTag'
    , gssLogoTag = 'gssLogoTag'
    , closeTeacherGuideMenuTag = 'closeTeacherGuideMenuTag'
    , openTeacherGuideMenuTag = 'openTeacherGuideMenuTag'
    , openAppsMenuTag = 'openAppsMenuTag'
    , closeAppsMenuTag = 'closeAppsMenuTag'
    , openActivityBookMenuTag = 'openActivityBookMenuTag'
    , closeActivityBookMenuTag = 'closeActivityBookMenuTag'

}

export default NavTranslationVariant;